<template>
  <v-card class="pa-2">
    <v-skeleton-loader :loading="firstLoad && loading" type="table">
      <v-row no-gutters align="center">
        <v-col cols="12" md="6">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn text v-bind="attrs" v-on="on" class="pa-2">
                <h3 class="color-services">{{ status.text }}</h3>
                <v-icon right color="#5c648b">mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in statuses"
                :key="index"
                @click="status = item"
              >
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col cols="12" md="6">
          <v-row no-gutters justify="end" align="center">
            <v-col v-if="$store.state.isMobile">
              <v-text-field
                outlined
                v-model="search"
                hide-details
                placeholder="Search"
                prepend-inner-icon="mdi-magnify"
                color="indigo accent-3"
                class="search-field"
              ></v-text-field>
            </v-col>

            <v-text-field
              v-if="!$store.state.isMobile"
              outlined
              v-model="search"
              hide-details
              placeholder="Search"
              prepend-inner-icon="mdi-magnify"
              color="indigo accent-3"
              class="pe-3 search-field"
            ></v-text-field>

            <v-btn
              v-if="!serviceProvider"
              color="indigo accent-3"
              class="search-btn ms-2"
              dark
              :to="{
                name: routerPath.adminPanel.children.serviceProvidersAdd.name,
              }"
            >
              <v-icon left>mdi-plus</v-icon>
              <span>Add Service provider</span>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-divider class="mt-2 mb-1"></v-divider>
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="pagination"
        :server-items-length="itemsTotal"
        :loading="loading"
        :page.sync="pagination.page"
        mobile-breakpoint="0"
        hide-default-footer
        @page-count="10"
      >
      <template v-slot:[`item.client_name`]="{ item }">
          {{formatClientName(item.client_details)}}
      </template>
        <template v-slot:[`item.id`]="{ item }">
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon color="#5c648b">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                :to="{
                  name:
                    routerPath.adminPanel.children.serviceProvidersDetails.name,
                    params:{id :item.user_details.id}
                }"
              >
                <v-list-item-title>Details</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="item.user_details.is_active"
                @click="actionServiceProvider(item.user_details.id, 'Block')"
              >
                <v-list-item-title>Block</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-else
                @click="actionServiceProvider(item.user_details.id, 'Un-block')"
              >
                <v-list-item-title>Un-block</v-list-item-title>
              </v-list-item>

              <v-list-item
                v-if="item.verification_status === 'Verified'"
                @click="
                  actionServiceProvider(item.user_details.id, 'Un-verify')
                "
              >
                <v-list-item-title>Make unverified</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-else
                @click="actionServiceProvider(item.user_details.id, 'Verify')"
              >
                <v-list-item-title>Make verified</v-list-item-title>
              </v-list-item>

              <v-list-item
                :to="{
                  name:
                    routerPath.adminPanel.children.serviceProvidersEdit.name,
                  params: { id: item.user_details.id },
                }"
              >
                <v-list-item-title>Edit</v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="actionServiceProvider(item.user_details.id, 'Delete')"
              >
                <v-list-item-title>Delete</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <!-- <template v-slot:item.roles_list="{ item }">
          <v-tooltip bottom color="#00000000">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <span
                  style="cursor: pointer;"
                  v-for="(element, index) in item.roles_list"
                  :key="element.id"
                  >{{ element.name }}
                  {{
                    item.roles_list.length != 1 && index + 1 != item.roles_list.length
                      ? ", "
                      : ""
                  }}</span
                >
              </div>
            </template>
            <v-card class="mx-auto">
              <v-card-text>
                <p class="text--primary">
                  <span
                    v-for="(element, index) in item.roles_list"
                    :key="element.id"
                  >
                    {{ element.name }}
                    <br v-if="index != item.roles_list.length - 1" />
                  </span>
                </p>
              </v-card-text>
            </v-card>
          </v-tooltip>
        </template> -->
        <template v-slot:[`item.roles_list`]="{ item }">
          <v-tooltip bottom content-class="tooltip-custom">
            <template v-slot:activator="{ on }">
              <span
                v-on="on"
                style="cursor: pointer;"
                v-for="(element, index) in item.roles_list"
                :key="element.id"
                >{{ element.name }}
                {{
                  item.roles_list.length != 1 &&
                  index + 1 != item.roles_list.length
                    ? ", "
                    : ""
                }}
              </span>
            </template>
            <span v-for="(element, index) in item.roles_list" :key="element.id">
              {{ element.name }}
              <br v-if="index != item.roles_list.length - 1" />
            </span>
          </v-tooltip>
        </template>
        <!-- <template v-slot:item.role_details="{ item }">{{
        item.role_details.name
        }}</template>-->

        <template v-slot:[`item.user_details.is_active`]="{ item }">
          <span :class="getTextColor(item.user_details.is_active)">{{
            item.user_details.is_active ? "Active" : "Inactive"
          }}</span>
        </template>

        <template v-slot:no-data>
          <EmptyState text="Service Provider" />
        </template>
      </v-data-table>

      <v-divider class="mt-1 mb-2"></v-divider>
      <v-row align="center" justify-md="end" v-if="!$store.state.isMobile">
        <span class="body-2 text-color" style="margin-end: 73px">
          Showing
          {{
            pagination.itemsPerPage * pagination.page -
              pagination.itemsPerPage +
              1
          }}
          -
          {{
            pagination.itemsPerPage * pagination.page > itemsTotal
              ? itemsTotal
              : pagination.itemsPerPage * pagination.page
          }}
          of {{ itemsTotal }}
        </span>

        <v-btn
          text
          color="indigo accent-3 body-2"
          :disabled="1 == pagination.page"
          @click="pagination.page = pagination.page - 1"
        >
          <span>Previous</span>
        </v-btn>

        <span class="body-2 text-color ms-9 me-9"
          >Page {{ pagination.page }}</span
        >

        <v-btn
          text
          color="indigo accent-3"
          :disabled="
            Math.ceil(itemsTotal / 10) == pagination.page || itemsTotal == 0
          "
          @click="pagination.page = pagination.page + 1"
        >
          <span>Next</span>
        </v-btn>
      </v-row>

      <v-row v-else align="center" justify="center">
        <v-row class="ma-0 pt-2" align="center" justify="center">
          <v-btn
            text
            color="indigo accent-3 body-2"
            :disabled="1 == pagination.page"
            @click="pagination.page = pagination.page - 1"
          >
            <span>Previous</span>
          </v-btn>

          <span class="body-2 text-color ms-9 me-9"
            >Page {{ pagination.page }}</span
          >

          <v-btn
            text
            color="indigo accent-3"
            :disabled="Math.ceil(itemsTotal / 10) == pagination.page"
            @click="pagination.page = pagination.page + 1"
          >
            <span>Next</span>
          </v-btn>
        </v-row>
        <v-col cols="12" align="center">
          <span class="body-2 text-color">
            Showing
            {{
              pagination.itemsPerPage * pagination.page -
                pagination.itemsPerPage +
                1
            }}
            -
            {{
              pagination.itemsPerPage * pagination.page > itemsTotal
                ? itemsTotal
                : pagination.itemsPerPage * pagination.page
            }}
            of {{ itemsTotal }}
          </span>
        </v-col>
      </v-row>
    </v-skeleton-loader>
    <v-dialog v-model="promptModal" max-width="450">
      <v-card>
        <v-card-title>
          <span class="modal-heading">Are you sure?</span>
          <v-spacer></v-spacer>
          <v-btn
            color="indigo accent-3"
            text
            @click="promptModal = false"
            class="search-btn"
          >
            <v-icon size="16" left>mdi-close</v-icon>
            <span>Close</span>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <span class="custom-lable-field"
            >Do you want to <span v-text="action"> </span> this Service Provider
            ?</span
          >
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="flat accent-3"
            dark
            style="width:100px"
            class="mb-4 me-2"
            @click="promptModal = false"
            >No</v-btn
          >
          <v-btn
            color="indigo accent-3"
            dark
            style="width:100px"
            class="mb-4 me-2"
            @click="actionService()"
            >Yes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { API_ADMIN_URL,API_COMMON_URL, ROUTER_URL } from "../../../../../constants/urls";

import Keys from "../../../../../constants/keys";
import Axios from "../../../../../api/BaseAxios";

import EmptyState from "../../../../../components/EmptyState/EmptyState";

import store from "../../../../../store";

export default {
  name: "ServiceProviderTable",
  components: {
    EmptyState,
  },
  data() {
    return {
      routerPath: ROUTER_URL,
      items: [],
      search: "",
      itemsTotal: 0,
      loading: true,
      firstLoad: true,
      promptModal: false,
      action: "",
      serviceProviderId: 0,
      pagination: { sortBy: ["name"], sortDesc: [false] },
      status: {
        value: 0,
        text: "All Service Providers",
      },
      statuses: [
        {
          value: 0,
          text: "All Service Providers",
        },
        {
          value: 1,
          text: "Verified Service Providers",
        },
        {
          value: 2,
          text: "Un-Verified Service Providers",
        },
        {
          value: 3,
          text: "Active Service Providers",
        },
        {
          value: 4,
          text: "In-Active Service Providers",
        },
      ],
      headers: [
        {
          text: "Name",
          value: "user_details.name",
          class: "black--text font-weight-bold ",
        },
        {
          text: "Email",
          value: "user_details.registered_email",
          class: "black--text font-weight-bold ",
        },
        {
          text: "Phone",
          value: "user_details.mobile",
          class: "black--text font-weight-bold ",
        },
        {
          text: "Roles",
          value: "roles_list",
          class: "black--text font-weight-bold ",
        },
        {
          text: "Status",
          value: "user_details.is_active",
          class: "black--text font-weight-bold",
          sortable: false,
        },
        {
          text: "Verification Status",
          value: "verification_status",
          class: "black--text font-weight-bold",
          sortable: false,
        },
        {
          text: "Client",
          value: "client_name",
          class: "black--text font-weight-bold",
          sortable: false,
        },
        {
          text: "Added By",
          value: "added_by_details.name",
          class: "black--text font-weight-bold",
          sortable: false,
        },
        {
          sortable: false,
          text: "Action",
          value: "id",
          class: "black--text font-weight-bold",
          align: "center",
        },
      ],
      rowsPerPageItems: [5, 10, 20, 50, 100],
      serviceProvider: false,
    };
  },
  watch: {
    pagination() {
      if (!this.firstLoad) this.getMemberData();
      this.firstLoad = false;
    },
    search() {
      this.pagination.page = 1;
      this.getMemberData();
    },
    status() {
      this.pagination.page = 1;
      this.getMemberData();
    },
  },
  methods: {
    getMemberData() {
      this.loading = true;
      const self = this;
      const successHandler = (res) => {
        self.loading = false;
        self.items = res.data.data;
        self.itemsTotal = res.data.recordsTotal;
      };

      const failureHandler = (res) => {
        console.log(res);
        self.loading = false;
      };

      let dataTableParams = {};
      dataTableParams[Keys.LENGTH] = this.pagination.itemsPerPage
        ? this.pagination.itemsPerPage
        : 10;
      dataTableParams[Keys.PAGE] = this.pagination.page;
      dataTableParams[Keys.SEARCH] = this.search;
      dataTableParams[Keys.IS_SERVICE_PROVIDER] = this.serviceProvider;
      // console.log("________________________________");
      // console.log(this.status.value);
      dataTableParams[Keys.STATUS] = this.status.value;
      try {
        for (let a = 0; a < this.headers.length; a++) {
          if (
            this.pagination.sortBy.length > 0 &&
            this.pagination.sortBy[0] == this.headers[a].value
          ) {
            dataTableParams[Keys.SORTING_COLUMN] = a;
            dataTableParams[Keys.FLAG_DESCENDING] = this.pagination.sortDesc[0];
          }
        }
      } catch (error) {
        console.log(error);
      }

      Axios.request_POST(
        API_COMMON_URL.serviceProviderList,
        dataTableParams,
        {},
        successHandler,
        failureHandler
      );
    },
    getColor(status) {
      if (status) return "green";
      else return "red";
    },
    getTextColor(status) {
      if (status) return "green--text";
      else return "red--text";
    },
    actionServiceProvider(id, action) {
      this.promptModal = true;
      this.action = action;
      this.serviceProviderId = id;
    },
    formatClientName(client_details){
      return (client_details!=null? client_details.name: 'N/A'); 
    },
    actionService() {
      const self = this;
      alert(this.action);
      const successHandler = (res) => {
        //console.log(res.data.data);

        store.dispatch("snackBar/showToast", {
          message: "Service provider" + " " + self.action,
          color: "S",
        });
        self.formSubmitLoading = false;
        self.promptModal = false;
        self.getMemberData();
      };

      const failureHandler = (res) => {
        console.log(res);
        self.formSubmitLoading = false;
      };

      let requestParams = {};

      requestParams[Keys.ID] = this.serviceProviderId;

      let patchRequest = true;

      if (this.action == "Delete") {
        this.action = "deleted";
        patchRequest = false;
        Axios.request_DELETE(
          API_ADMIN_URL.serviceProvidersDelete,
          requestParams,
          {},
          successHandler,
          failureHandler,
          false
        );
      } else if (this.action == "Block") {
        this.action = "blocked";
        requestParams["block_unblock_user"] = 0;
      } else if (this.action == "Un-block") {
        this.action = "Un-blocked";
        requestParams["block_unblock_user"] = 1;
      } else if (this.action == "Un-verify") {
        this.action = "Un-verified";
        requestParams["status"] = 0;
      } else if (this.action == "Verify") {
        this.action = "Verified";
        requestParams["status"] = 1;
      }

      if (patchRequest) {
        Axios.request_PATCH(
          API_ADMIN_URL.serviceProviderStatusUpdate,
          requestParams,
          {},
          successHandler,
          failureHandler,
          false
        );
      }
    },
  },
  created() {
    if (
      this.$route.name ==
      ROUTER_URL.clientPanel.children.clientServiceProviderList.name
    ) {
      this.serviceProvider = true;
    }
  },
  mounted() {
    this.getMemberData();
  },
};
</script>

<style scoped>
.color-services {
  color: #5c648b;
}
</style>
